/// <amd-module name="Wiki/WitQuerySelector/Helper" />
import { QueryHierarchyItem, QueryType } from "Wiki/Clients/Wit/Contracts/WorkItemTracking";

export const pathSeparator = "/";

export interface QueryTreeItem extends QueryHierarchyItem {
    nodeId?: string;
}

export interface QueryProperties {
    isFilteredQuery?: boolean;
    isFavoritedQuery?: boolean;
}

export function getIconName(queryType: QueryType): string {
    switch (queryType) {
        case QueryType.Flat:
            return "ViewList";
        case QueryType.OneHop:
            return "ViewListGroup";
        case QueryType.Tree:
            return "ViewListTree";
        default:
            return "FabricFolder";
    }
}

export function getQueryProperties(query: QueryTreeItem, isFilteredQuery: boolean): QueryProperties {
    return {
        isFilteredQuery,
        isFavoritedQuery: isFilteredQuery ? undefined : !!query.nodeId // in case of filtered results, there is no concept of favorited queries.
    };
}

export function getSharedQueries(queries: QueryTreeItem[]): QueryTreeItem[] {
    return queries.filter(query => query.isPublic);
}
